import { type UseQueryResult, useQuery } from 'react-query';
import {
  VinylService,
  Wealthlane_AwardService_Dtos_TransferAgents_ActiveTransferAgentIntegrationDto,
} from '../../services/wealthlane-award-services';

const useGetVinylExternalReservePool = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  activeTransferAgent:
    | Wealthlane_AwardService_Dtos_TransferAgents_ActiveTransferAgentIntegrationDto
    | undefined
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Array<{
      label: string | null;
      value: string | null;
      quantity: string | null;
    }>
  | undefined,
  unknown
> => {
  const vinylExternalReservePool = useQuery(
    ['getVinylExternalReservePool', activeTransferAgent],
    async () => {
      if (activeTransferAgent?.isActive && activeTransferAgent?.integrationName === 'Vinyl') {
        return await handleRequest(VinylService.getApiAwardApiAppVinylExternalReservePools());
      }
    },
    {
      select: (response) => {
        return response?.data?.map((item) => {
          return {
            label: `${item?.pool_name}`,
            value: item?.id ?? '',
            quantity: item?.quantity ?? '',
          };
        });
      },
    }
  );

  return vinylExternalReservePool;
};

export default useGetVinylExternalReservePool;
